<template>
    <TeaserMessage>{{ bot.messages.popup_message }}</TeaserMessage>
    <Transition
        name="chat-window"
        enter-active-class="chat-window-active"
        leave-active-class="chat-window-leave"
    >
    <ChatWindowFrame>
        <ChatHeader/>
        <ChatMessagesList />
        <ChatInput  />
        <ChatBranding />
    </ChatWindowFrame>
    </Transition>
</template>
  
<script setup>
import TeaserMessage from './TeaserMessage.vue';
import ChatHeader from './Chat/ChatHeader.vue';
import { computed } from 'vue';
import ChatInput from './Chat/ChatInput.vue';
import {useWidgetStore} from '../store/widget.js';
import ChatWindowFrame from './Chat/ChatWindowFrame.vue';
import ChatBranding from './Chat/ChatBranding.vue';
import ChatMessagesList from './Chat/ChatMessagesList.vue';

// import lang from '../lang.js';
// const currentLang = lang[window.CierraChatWidget.lang];

const widgetStore = useWidgetStore();
const bot = computed(() => widgetStore.bot);



</script>
